import { call, put, takeLatest } from 'redux-saga/effects';

import { GET_SECURITY_LOADING_REPORTS_REQUEST } from './constants';
import { SecurityLoadingReportService } from './service';
import {
  getSecurityLoadingReportsError,
  getSecurityLoadingReportsRequest,
  getSecurityLoadingReportsSuccess,
} from './actions';
import { SecurityLoadingReport } from './interfaces';

function* getLoadingReportsSaga(action: ReturnType<typeof getSecurityLoadingReportsRequest>) {
  try {
    const { branchId, startDate, endDate, notLoadedMode } = action.payload;

    const reports: SecurityLoadingReport[] = yield call(
      SecurityLoadingReportService.getReports,
      branchId,
      startDate,
      endDate,
      notLoadedMode,
    );
    yield put(getSecurityLoadingReportsSuccess(SecurityLoadingReportService.formatReportForTable(reports)));
  } catch (error: any) {
    yield put(getSecurityLoadingReportsError(error));
  }
}

export function* reportLoadingSagaWatcher() {
  yield takeLatest(GET_SECURITY_LOADING_REPORTS_REQUEST, getLoadingReportsSaga);
}
